module.exports = __webpack_public_path__ + "static/media/grip.70b8d99f.svg";